import { useSelector } from "react-redux";

import {
  ChangeNameForm,
  NotificationsForm,
  AccountRemovalForm,
  VerifyForm,
} from "../../components/forms/settings";
import ProfileLayout from "../../layouts/Profile.layout";
import { selectCurrentUser } from "../../store/reducers/user";
import { AccountType } from "../../types/UserTypes";
import { isMobileMedia } from "../../utils/media";
import { useVerifyForm } from "../../hooks/useVerifyForm";

export const Profile = () => {
  const { account_type, first_name, last_name, kyc_complete } =
    useSelector(selectCurrentUser);

  const showVerifyForm = useVerifyForm(!isMobileMedia());

  return (
    <ProfileLayout>
      <h1 className="hidden md:block theme-heading text-center mb-8">
        General Settings
      </h1>

      <div className="hidden md:block theme-subheading text-center mb-16">
        Personal details and notifications
      </div>

      {showVerifyForm && (
        <VerifyForm className="mb-12" orientation="horizontal" />
      )}

      <ChangeNameForm
        account_type={account_type}
        first_name={first_name}
        last_name={last_name}
        disabled={account_type === AccountType.CONTRACTOR && kyc_complete}
        className="mb-8 md:mr-3"
      />
      <div className="md:mr-3">
        <NotificationsForm />

        <AccountRemovalForm />
      </div>
    </ProfileLayout>
  );
};
